// §4.4 partial — admin/history routes.
import type { RouteObject } from "react-router-dom";

const routes: RouteObject[] = [];

export default routes;
